/** Unit of accrued time. */
export enum WorktimeImportAccrualUnit {
  /** Hours */
  Hours = "hours",
  /** Days */
  Days = "days",
}

(()=>{ /* Snowpack Noop HACK for: https://github.com/snowpackjs/snowpack/issues/3585 */ })();